import React from 'react'
import PropTypes from 'prop-types'
import ScoresTable from './ScoresTable'
import ExplainPanel from './ExplainPanel'
import { formatDate } from 'Shared/helpers'
import { useWhsTerms } from '../whs_terms_context'

const t = (key, opts) => !window.I18n ? '' : window.I18n.t(key, opts)

const TABS = ['active', 'inactive']

const ScoresSection = ({
  scores, activeTab, onTabChange, onDeleteScore, scoreExplanations, saving,
  activeHoles, currentHi, calculatedAt, showExplain, onToggleExplain, showAddForm, onToggleAddForm,
  explanation, readOnly,
}) => {
  const whsTerms = useWhsTerms()

  const mostRecentActiveScore = (scores.active || []).reduce((newest, s) => {
    if (!s.play_at) return newest
    if (!newest) return s
    return new Date(s.play_at) > new Date(newest.play_at) ? s : newest
  }, null)

  // The abbrev ("H.I.™" / "HDCP") comes from WhsTermFormats; here we only pick
  // the 9- vs 18-hole wrapper key.
  const hiLabelKey = activeHoles === '9' ? 'hi_label_9' : 'hi_label'

  return (
    <div className='scores-section'>
      <div className='scores-section__header'>
        <div className='scores-section__meta'>
          <span className='scores-section__hi-badge'>
            {t('member_handicap_history.scores_section.' + hiLabelKey, whsTerms)}{' '}{currentHi || '—'}
          </span>
          <button
            type='button'
            className={`hs-action-btn scores-section__explain-btn${showExplain ? ' hs-action-btn--active' : ''}`}
            onClick={onToggleExplain}
            onMouseDown={e => e.preventDefault()}
          >
            <i className='fa fa-info-circle' />
          </button>
          {calculatedAt && (
            <span className='scores-section__calculated-at'>{t('member_handicap_history.scores_section.calculated_prefix')}{formatDate(calculatedAt, null, 'MMM D, YYYY')}</span>
          )}
        </div>
        <div className='scores-section__tab-switcher'>
          {TABS.map(tab => (
            <button
              key={tab}
              type='button'
              onClick={() => onTabChange(tab)}
              className={`segment-btn segment-btn--wide segment-btn--large${activeTab === tab ? ' segment-btn--active' : ''}`}
            >
              {t('member_handicap_history.scores_section.' + tab)}
              {' ('}{(scores[tab] || []).length}{')'}
            </button>
          ))}
        </div>
        {!readOnly && (
          <div className='scores-section__add-btn-wrapper'>
            <button
              type='button'
              className='btn btn-default btn-sm'
              onClick={onToggleAddForm}
              disabled={saving}
            >
              {t('member_handicap_history.scores_section.add_score')}
            </button>
          </div>
        )}
      </div>
      {showExplain && (
        <ExplainPanel
          explanation={explanation}
          mostRecentScore={mostRecentActiveScore}
          scoreExplanations={scoreExplanations}
        />
      )}
      <ScoresTable
        scores={scores[activeTab] || []}
        onDelete={onDeleteScore}
        scoreExplanations={scoreExplanations}
        saving={saving}
        readOnly={readOnly}
      />
    </div>
  )
}

ScoresSection.defaultProps = {
  readOnly: false,
  onDeleteScore: null,
  onToggleAddForm: null,
}

ScoresSection.propTypes = {
  scores: PropTypes.shape({
    active: PropTypes.array,
    inactive: PropTypes.array,
    calculated: PropTypes.array,
  }),
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  onDeleteScore: PropTypes.func,
  scoreExplanations: PropTypes.object,
  saving: PropTypes.bool,
  activeHoles: PropTypes.string,
  currentHi: PropTypes.string,
  calculatedAt: PropTypes.string,
  showExplain: PropTypes.bool.isRequired,
  onToggleExplain: PropTypes.func.isRequired,
  showAddForm: PropTypes.bool.isRequired,
  onToggleAddForm: PropTypes.func,
  explanation: PropTypes.object,
  readOnly: PropTypes.bool,
}

export default ScoresSection
